import { render, staticRenderFns } from "./TableTable.vue?vue&type=template&id=5598bc05"
import script from "./TableTable.vue?vue&type=script&lang=ts"
export * from "./TableTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports